import React, { useEffect, useState } from "react";
import ic_car_outline from "../img/ic_toyota_main_category.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "./Header";
import axios from "axios";
import ic_no_image from "../img/ic_no_image_available_big.png";

import ic_model_bg from "../img/2_cars.png";
import ic_search_white_icon from "../img/ic_search_header.png";
import "../css/ShowModel.css";
import model_page_bg from "../img/model_page_bg.png";


import brand_1 from "../img/br1.png";
import brand_2 from "../img/br2.png";
import brand_3 from "../img/br3.png";
import brand_4 from "../img/br4.png";
import brand_5 from "../img/br5.png";
import brand_6 from "../img/br6.png";
import brand_7 from "../img/br7.png";
import brand_8 from "../img/br8.png";
import ytm from "../img/yt_mirror.png";
import rbi from "../img/rbi.png";
import krc from "../img/krc_original_logo.png";


import toyota from "../img/TOYOTA.svg";
import nissan from "../img/nissan.svg";
import mitsubishi from "../img/mitsubishi.svg";
import suzuki from "../img/suzuki.png";
import mazda from "../img/mazda.svg";
import honda from "../img/honda.png";
import hyundai from "../img/hyundai.png";
import ford from "../img/ford.png";
import gmc from "../img/gmc.svg";
import kia from "../img/kia.svg";
import lexus from "../img/lexus.png";


import Marquee from "react-fast-marquee";


function ShowModel() {

    const [isCallingApi, setIsCallingAPI] = useState(false)
    const [filteredModelList, setFilteredModelList] = useState(null);

    const [modelNameList, setModelNameList] = useState(null);

    const [searchParams, setSearchParams] = useSearchParams();

    const makename = searchParams.get('makename');

    console.log("makeName ", makename);

    const navigate = useNavigate()

    const clickedOnModel = (modelname) => {
        // directly go to item list instead of year page
        // navigate(`/show_year?makename=${makename}&modelname=${modelname}`)
        navigate(`/show_parts_list?makename=${makename}&modelname=${modelname}&modelyear=2024&maincategory=all&subcategory=all`)
    }

    const callAPIToGetModelNames = () => {

        setIsCallingAPI(true)

        axios.get(`https://cubixweberp.com:197/api/InventMasters/InventoryLevel2?cmpcode=AUTOLAND&guid=C406671E-B36F-4D24-B0D2-04D129936FBE&mod=LEVEL2&lvl1=${makename}`).then((res) => {
            setModelNameList(res.data)

            setFilteredModelList(res.data)

            setIsCallingAPI(false)
        }).catch((err) => {
            console.log("err ", err)
            setIsCallingAPI(false)
        })
    }

    const filterFromList = (typedCharacter) => {

        let typedCharacterValue = typedCharacter.target.value;

        if (typedCharacterValue?.length == 0) {

            setFilteredModelList(modelNameList)

        }

        else {

            if (modelNameList) {
                if (modelNameList?.length > 0) {

                    let filteredArray = modelNameList.filter((element) => element.Model.toLowerCase().includes(typedCharacterValue.toLowerCase()))

                    console.log("filtered Array ", filteredArray)

                    setFilteredModelList(filteredArray)

                } else {

                }
            }
        }
        //
    }

    useEffect(() => {

        callAPIToGetModelNames()

        // Scroll to the top when the component mounts
        window.scrollTo(0, 0);

    }, [])

    return (
        <div className="ShowModel-root-container ">

            <div className="Header-wrapper">
                <Header />
            </div>

            <div className="Show-container p-4 ShowModel_body_bg ">


                <img className="Show_model_page_bg" src={model_page_bg} />

                <div className="container">


                    <h6>Select Model of {makename}</h6>

                    {isCallingApi &&
                        <div className="show_model_load_more_container">

                            <div className="spinner-border" role="status">

                            </div>
                            <span className="sr-only ms-2">Loading...</span>
                        </div>
                    }

                    <div className="d-flex Select-model-left-right-container">


                        <div className="Show-container-inner">


                            <div className="model_search_box_div">
                                <img src={ic_search_white_icon} />
                                <input className="model_search_input" placeholder="Search here" onChange={(e) => filterFromList(e)} />
                            </div>

                            {
                                filteredModelList?.map((item) => {
                                    return (
                                        <div key={item.Model} className="list-item-single" onError={(e) => {
                                            e.target.src = ic_no_image;
                                        }} onClick={() => clickedOnModel(item.Model)}>

                                            <p>{item.Model}</p>
                                        </div>
                                    )
                                })
                            }

                            {
                                filteredModelList?.length == 0 &&

                                <div className="list-item-single" >
                                    <p>No results found</p>
                                </div>
                            }
                        </div>

                        <div className="Show-model-brand-container d-none d-sm-block">

                            <img className="model_bg_right_side" src={ic_model_bg} />

                            <div className="show_model_brands_we_deal_container">
                                <Marquee>
                                    <div>
                                        <img src={brand_2} />
                                    </div>
                                    <div>
                                        <img src={brand_1} />
                                    </div>
                                    <div>
                                        <img src={brand_4} />
                                    </div>
                                    <div>
                                        <img src={brand_6} />
                                    </div>
                                    <div>
                                        <img src={brand_8} />
                                    </div>
                                    <div>
                                        <img src={ytm} />
                                    </div>
                                    <div>
                                        <img src={brand_5} />
                                    </div>
                                    <div>
                                        <img src={rbi} />
                                    </div>
                                    <div>
                                        <img src={krc} />
                                    </div>
                                    <div>
                                        <img src={brand_3} />
                                    </div>
                                    <div>
                                        <img src={brand_7} />
                                    </div>
                                </Marquee>
                            </div>

                            <div className="show_model_make_we_deal_container">
                                <Marquee direction="right">
                                    <div>
                                        <img src={toyota} />
                                    </div>
                                    <div>
                                        <img src={nissan} />
                                    </div>
                                    <div>
                                        <img src={mitsubishi} />
                                    </div>
                                    <div>
                                        <img src={suzuki} />
                                    </div>
                                    <div>
                                        <img src={mazda} />
                                    </div>
                                    <div>
                                        <img src={honda} />
                                    </div>
                                    <div>
                                        <img src={hyundai} />
                                    </div>
                                    <div>
                                        <img src={ford} />
                                    </div>
                                    <div>
                                        <img src={gmc} />
                                    </div>
                                    <div>
                                        <img src={kia} />
                                    </div>
                                    <div>
                                        <img src={lexus} />
                                    </div>
                                </Marquee>
                            </div>

                        </div>

                    </div>

                </div>


            </div>



        </div>
    )
}

export default ShowModel;